/**
 * Qual etapa o select da visao Tabela deve mandar para o backend.
 *
 * Regra pura extraida do `CrmBoard` para ter teste: a Tabela decidia sozinha
 * ("etapa diferente da atual"), enquanto o Kanban (handleDrop) e o cockpit
 * (MoverEtapaDialog) ja usavam `moverTemEfeito`. Com isso, o lead preso em
 * "Convertido" sem ganho nao tinha conserto pela Tabela: escolher a propria
 * coluna nao fazia nada (FORM-20).
 */

import { moverTemEfeito } from "../../utils/crmPermissoes";

export function destinoDaTabela(colunas, lead, etapaId) {
  const destino = (colunas || []).find(
    (c) => String(c.etapa?.id) === String(etapaId)
  )?.etapa;
  if (!destino || !lead) return null;
  return moverTemEfeito(lead._etapaId, destino, lead) ? destino : null;
}
